import { gql as cacheGql } from '@apollo/client'

import client from '..'
import { forceCacheRefresh } from '../graphql/onboarding-client'

export const updateCachedOnboardingSectionsProgress = async (
  accountID: string,
  type: 'user' | 'account',
  data: {
    onboardingSectionID: string
    sectionCompleted: boolean
    sectionSkipped: boolean
    sectionSkippedBefore: boolean
  }[],
) => {
  const typeName =
    type === 'user' ? 'userOnboardingProgress' : 'accountOnboardingProgress'

  client.writeQuery({
    query: cacheGql`
        mutation UpdateOnboardingSections {
          ${typeName} {
            ${`${typeName}List`} {
              onboardingSectionID
              sectionCompleted
              sectionSkipped
              sectionSkippedBefore
            }
          }
        }
      `,
    data: {
      [typeName]: {
        __typename: type === 'user' ? 'UserOnboarding' : 'AccountOnboarding',
        [`${typeName}List`]: data,
      },
    },
  })

  await forceCacheRefresh(accountID, type === 'account')
}
